import { render, staticRenderFns } from "./__AddTemModal.vue?vue&type=template&id=f0f54070&"
import script from "./__AddTemModal.vue?vue&type=script&lang=js&"
export * from "./__AddTemModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports